var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.0001 7.66666C14.5284 7.66666 7.66675 14.5283 7.66675 23C7.66675 31.4717 14.5284 38.3333 23.0001 38.3333C31.4717 38.3333 38.3334 31.4717 38.3334 23C38.3334 14.5283 31.4717 7.66666 23.0001 7.66666Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9808 3.83334C12.4008 3.83334 3.83325 12.42 3.83325 23C3.83325 33.58 12.4008 42.1667 22.9808 42.1667C33.5799 42.1667 42.1666 33.58 42.1666 23C42.1666 12.42 33.5799 3.83334 22.9808 3.83334ZM22.9999 38.3333C14.5283 38.3333 7.66659 31.4717 7.66659 23C7.66659 14.5283 14.5283 7.66668 22.9999 7.66668C31.4716 7.66668 38.3333 14.5283 38.3333 23C38.3333 31.4717 31.4716 38.3333 22.9999 38.3333Z",
    fill: "white",
    fillOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3333,
    y: 30.6667,
    width: 15.3333,
    height: 1.91666,
    fill: "white",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0833,
    y: 27.0041,
    width: 15.3333,
    height: 2.875,
    transform: "rotate(-60 21.0833 27.0041)",
    fill: "#FF9400",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.42e600cf79cc2e2f87b54a2d0fd591a9.svg";
export { ForwardRef as ReactComponent };